module.exports = "<span class={{item.status}}>\r\n  <a class=\"msg\">\r\n    <img src={{item.image}} alt=\"\" class=\"air air-top-left margin-top-5\" width=\"40\"\r\n         height=\"40\"/>\r\n    <span class=\"from\">{{item.title}}</span>\r\n    <span>{{item.time}}</span>\r\n    <span class=\"subject\">{{item.subject}}</span>\r\n    <span class=\"msg-body\">{{item.message}}</span>\r\n  </a>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/header/activities/activities-message/activities-message.component.html
// module id = ./src/app/shared/layout/header/activities/activities-message/activities-message.component.html
// module chunks = main